import Utils from "../../services/Utils.js";
import {} from "../../js/api/leagues.js";
import {getLeagues} from "../../js/api/leagues.js";
import {getFeaturedMatches} from "../../js/api/featuredPreMatch.js";
import { _t } from "../../services/TranslationService.js";
let leagues = [];
let Leagues = {
    render : async () => {
        let request = Utils.parseRequestURL();
        leagues = await getLeagues(request.id);
        console.log(leagues);

        let sportId = '';
        if( !leagues.length == 0){
            sportId = leagues[0].sport_id
        }else {
            sportId = 1
        }

        let sportName = '';
        if( !leagues.length == 0  ){
            sportName = leagues[0].sport
        }else {
            sportName = 1
        }
        let featuredPrematchView = '';
        let featuredPrematchs = await getFeaturedMatches(sportId);

        let leagueView = '';
        leagues.forEach(league => {
            // <a href="#/p/${post.id}">${post.title}</a>
            leagueView = leagueView + `<a class="leagueListContentItem" href="#/games/${league.id}" data-id="${league.id}">${league.name}</a>`;
        });

        if( !featuredPrematchs.length == 0 )
            featuredPrematchs.forEach((featuredPrematch) => {
                if (featuredPrematch.odd){
                featuredPrematchView = featuredPrematchView + `<div class="featuredPrematchItem">
                   <a href="#/Match/${featuredPrematch.id}" class="featuredMatchName">
                       <span>${featuredPrematch.home_team}</span>
                       <span>${featuredPrematch.away_team}</span>
                    </a>
                    <span class="featurePreMatchDate">${Utils.formatDate(featuredPrematch.game_date, featuredPrematch.game_time, 'withoutYear')}</span>
                    <span class="numberofmarkets">${featuredPrematch.count_options} ></span>
                    <div class="featuredMatchBtn">
                        <div class="singleHomeOdd bettingBtn ${Utils.formatNumber(featuredPrematch.odd.split(',')[0].split('|')[1])  == 1 ? 'disabledBtn' : '' } ${featuredPrematch.odd.split(',')[0].split('|')[0]}" match-odd="${Utils.formatNumber(featuredPrematch.odd.split(',')[0].split('|')[1])}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${featuredPrematch.odd.split(',')[0].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[0].split('|')[0]}" bet-id="${(featuredPrematch.odd.split(',')[0].split('|')[0])}" game-id="${featuredPrematch.id}"><i>${featuredPrematch.odd.split(',')[0].split('|')[2]}</i><i>${Utils.formatNumber(featuredPrematch.odd.split(',')[0].split('|')[1])}</i></div>
                         <div class="singleDrawOdd bettingBtn ${Utils.formatNumber(featuredPrematch.odd.split(',')[1].split('|')[1])  == 1 ? 'disabledBtn' : '' } ${featuredPrematch.odd.split(',')[1].split('|')[0]}" match-odd="${Utils.formatNumber(featuredPrematch.odd.split(',')[1].split('|')[1])}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${featuredPrematch.odd.split(',')[1].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[1].split('|')[0]}" bet-id="${(featuredPrematch.odd.split(',')[1].split('|')[0])}" game-id="${featuredPrematch.id}"><i>${featuredPrematch.odd.split(',')[1].split('|')[2]}</i><i>${Utils.formatNumber(featuredPrematch.odd.split(',')[1].split('|')[1])}</i></div>
                        ${featuredPrematch.odd.split(',').length > 2 ? `<div class="singleAwayOdd bettingBtn ${Utils.formatNumber(featuredPrematch.odd.split(',')[2].split('|')[1]) == 1 ? 'disabledBtn' : '' } ${featuredPrematch.odd.split(',')[2].split('|')[0]}" match-odd="${Utils.formatNumber(featuredPrematch.odd.split(',')[2].split('|')[1])}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${featuredPrematch.odd.split(',')[2].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[2].split('|')[0]}" bet-id="${(featuredPrematch.odd.split(',')[2].split('|')[0])}" game-id="${featuredPrematch.id}"><i>${featuredPrematch.odd.split(',')[2].split('|')[2]}</i><i>${Utils.formatNumber(featuredPrematch.odd.split(',')[2].split('|')[1])}</i></div>`:``} 
                    </div>
              </div>`}
            });




        // let posts = await getPostsList()
        let view =  /*html*/`
            <div class="pageHeaderTitle">
                <a class="backBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                </a>
                <span>${sportName}</span>
                <a href="#/InPlay/${sportId}" class="liveTitleBtn">${_t('Live <i>InPlay</i>')}</a>
            </div>
            <div class="betModule liveInModule m-t-6 accordionDisable">
                 <div class="betModuleHeaderContainer"> 
                   <a class="betModuleHeaderBtn">
                     <span>${_t('Ndeshjet Kryesore')}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">
                     
                   </a>
                 </div>
            </div>
            <div class="featuredPrematchWrapper">
                <div class="featuredPrematchSlider">
                    ${featuredPrematchView}
                </div>            
            </div>
            
            <div class="leagueHeaderLabel m-t-6">
             <span>${_t('Leagues')}</span>
            </div>
            <div class="leagueHeaderContent">
                ${leagueView}
            </div>
       `
        return view
    }
    , after_render: async () => {

        $('body .featuredPrematchWrapper').each(function(){
            let featuredSliderWidth = 0;
            $(this).children('.featuredPrematchSlider').children('.featuredPrematchItem').each(function(){
                featuredSliderWidth += $(this).outerWidth() + 3;
                console.log('asdasd')
            });

            $(this).children('.featuredPrematchSlider').css({
                'width': featuredSliderWidth - 3 + 'px'
            });
        });


    }

}

export {Leagues, leagues};
